import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth.service';
import Loader from '../components/common/Loader';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                await AuthService.logout();
            } finally {
                if (window.Intercom) {
                    window.Intercom('shutdown'); // This shuts down the Intercom widget
                }
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
        })();
    }, [navigate]);

    return (
        <Loader fullHeight minHeight='100vh' text='Logging out...' fontSize='16px'/>
    );
};

export default Logout;
